export const PLAID_OAUTH_REDIRECT = 'plaid_oauth_redirect';
export const OAUTH_QUERY_PARAM = 'oauth_state_id';
